import { Component } from 'react'
import * as THREE from 'three'
import { dispose3DObject } from '../../../utils'

class SpriteSheet3D extends Component {
    constructor(props) {
        super(props)
        this.rootObj
    }

    componentDidMount() {
        const { rootObj, scene } = this.props
        this.rootObj = rootObj ? rootObj : scene
        this.mountSpriteSheet()
    }

    componentWillUnmount() {
        dispose3DObject(this.spriteContainer)
        this.rootObj = null
    }

    componentDidUpdate(prevProps) {
        const { isVisible, currentState, numberOfStates, stateIndexMap } = this.props

        if (!isVisible && prevProps.isVisible) {
            this.disposeSpriteSheet()
            this.rootObj.needsUpdate = true
        } else if (isVisible && !prevProps.isVisible) {
            this.mountSpriteSheet()
            this.rootObj.needsUpdate = true
        }

        if (prevProps.currentState !== currentState) {
            this.spriteContainer.children[0].material.map.offset.x = (1 / numberOfStates) * stateIndexMap[currentState]
            this.rootObj.needsUpdate = true
        }
    }

    disposeSpriteSheet = () => {
        this.spriteContainer.children.forEach((sprite, i) => {
            dispose3DObject(sprite)
        })
    }

    mountSpriteSheet = () => {
        const {
            spriteResource,
            meshPosition,
            spriteName,
            spriteScale,
            numberOfStates,
            currentState,
            stateIndexMap,
            depthOffset,
            renderOrder,
            materialColor,
            opacity,
        } = this.props
        this.spriteContainer = new THREE.Object3D()

        var spriteMap = new THREE.TextureLoader().load(spriteResource)
        spriteMap.wrapS = THREE.RepeatWrapping
        spriteMap.repeat.set(1 / numberOfStates, 1)
        spriteMap.offset.x = (1 / numberOfStates) * stateIndexMap[currentState]
        // var spriteMaterial = new THREE.SpriteMaterial({
        // https://stackoverflow.com/questions/52403652/three-js-disable-auto-rotate-of-sprite
        // Not using SpriteMaterial because auto-orientation towards camera is baked into shader.
        // Overcomplicates keeping things in line with the hitmesh.
        // If you want to use SpriteMaterial, will need to animate lookAt call in accompanying hitMesh
        var spriteMaterial = new THREE.MeshBasicMaterial({
            map: spriteMap,
            color: materialColor,
            sizeAttenuation: false,
        })

        var obj = new THREE.Sprite(spriteMaterial)
        obj.opacity = opacity
        obj.material.transparent = true
        if (renderOrder) {
            obj.material.depthTest = false
            obj.renderOrder = renderOrder
        }

        if (renderOrder) {
            obj.material.depthTest = false
            obj.renderOrder = renderOrder
            obj.onBeforeRender = function(renderer) {
                renderer.clearDepth()
            }
        }

        this.spriteContainer.name = spriteName
        this.spriteContainer.add(obj)
        this.rootObj.add(this.spriteContainer)
        if (meshPosition) {
            obj.position.set(meshPosition.x, meshPosition.y, meshPosition.z + depthOffset)
        } else if (depthOffset) {
            obj.position.set(0, 0, depthOffset)
        }
        if (spriteScale) obj.scale.set(spriteScale.x, spriteScale.y, spriteScale.z)

        // TO DO: NEED TO RECENTER PIVOT OF ROTATION AROUND PORTION OF ICON ASSET THAT'S SHOWN ??
        // https://stackoverflow.com/questions/28848863/threejs-how-to-rotate-around-objects-own-center-instead-of-world-center
    }

    //  TO DO: Need to figure out if (a) we need to animate using a sprite map, (b) if that's easily extensible with this setup
    // animateSprite = _ => {
    //     const { camera } = this.props
    //     // Rotate circle to face camera but don't rotate sprite
    //     // Keeps margin of circle constant wrt sprite image
    //     // this.pngSpriteObject.quaternion.copy(camera.quaternion)
    //     // this.rafMesh = requestAnimationFrame(this.animateSprite)
    // }

    render() {
        return null
    }
}

SpriteSheet3D.defaultProps = {
    opacity: 1,
    materialColor: 0xffffff,
    // depthOffset: 1,
    // meshPosition: {
    //     x: 0,
    //     y: 0,
    //     z: 2,
    // },
    // spriteScale: {
    //     x: 0.5,
    //     y: 0.5,
    //     z: 0.5,
    // },
}

export default SpriteSheet3D
